
import { ChannelType } from '../types';

export interface User {
  id: string;
  name: string;
  email: string;
  role: 'Administrator' | 'Accountant' | 'Viewer';
  status: 'Active' | 'Inactive';
  avatarInitials: string;
  authorizedChannels: ChannelType[];
}

export const usersData: User[] = [
  {
    id: 'u1',
    name: 'Daniel Kohler',
    email: 'd.kohler@io-market.com',
    role: 'Administrator',
    status: 'Active',
    avatarInitials: 'DK',
    authorizedChannels: [ChannelType.EBILL, ChannelType.EDI, ChannelType.EMAIL, ChannelType.PRINT]
  },
  {
    id: 'u2',
    name: 'Sarah Jenkins',
    email: 's.jenkins@io-market.com',
    role: 'Accountant',
    status: 'Active',
    avatarInitials: 'SJ',
    authorizedChannels: [ChannelType.EBILL, ChannelType.PRINT]
  },
  {
    id: 'u3',
    name: 'Michael Ross',
    email: 'm.ross@io-market.com',
    role: 'Viewer',
    status: 'Inactive',
    avatarInitials: 'MR',
    authorizedChannels: [ChannelType.EMAIL]
  },
  {
    id: 'u4',
    name: 'Elena Weber',
    email: 'e.weber@io-market.com',
    role: 'Accountant',
    status: 'Active',
    avatarInitials: 'EW',
    authorizedChannels: [ChannelType.EDI, ChannelType.EBILL]
  }
];
